import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { DealTypeContainer } from '../../containers/filters/DealTypeContainer';
import { IFilter } from '../../types/filters';

export const dealType: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: DealTypeContainer,
};
